import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/a/notices')({
  component: Component,
});

function Component() {
  return <div>Hello /a/notices!</div>;
}
